import PullBatchableQueue from './PullBatchableQueue';
import PushBatchableQueue from './PushBatchableQueue';
import { ResilienceMechanism } from './types';
// Enum isnt just a type, its also an object that needs to be
// exported as an object.
export { ResilienceMechanism };
export default ((retryQueuePrefix, product, options) => {
  switch (options === null || options === void 0 ? void 0 : options.resilienceMechanism) {
    case ResilienceMechanism.INDEXEDDB:
    case ResilienceMechanism.MEMORY:
      return new PullBatchableQueue(retryQueuePrefix, product, options);

    case ResilienceMechanism.LOCALSTORAGE:
    default:
      return new PushBatchableQueue(retryQueuePrefix, options);
  }
});